import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/images";
import OTPInput from "react-otp-input";
import { verifyOTP } from "../../services/authService";

const ForgotOTP = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const email = localStorage.getItem('email');
      await verifyOTP(email, otp);
      navigate("/reset-pass");
    } catch (err) {
      setError(err?.response?.data?.message || "Invalid OTP. Please try again.");
    }
  };

  return (
    <section className="login-section-bg">
      <div className="container-main">
        <div className="d-flex justify-content-center mb-2">
          <div className="auth-logo">
            <img
              src={images.logoHorizontal}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mt-2">
          <h3 className="mb-2 text-center text-primary fw-semibold fs-20">
            Check your inbox
          </h3>

          <form className="login-form" onSubmit={handleSubmit}>
            <p className="text-center fs-15">
              Enter the 6-digit code we sent to your email.
            </p>
            <div className="mt-4 text-center d-flex justify-content-center">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputType="tel"
                renderSeparator={<span> </span>}
                renderInput={(props) => (
                  <input {...props} className="otp-input" placeholder="-" />
                )}
              />
            </div>
            {error && <p className="text-danger fs-13 mt-2 mb-0 text-center">{error}</p>}
            <div className="mt-4 text-center">
              <button type="submit" className="btn btn-primary mt-2">
                Verify Email
              </button>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-3 fs-13 gap-1">
              <p className="mb-0 text-muted fs-13">Didn't receive the code?</p>
              <p className="mb-0 text-primary cursor-pointer text-decoration-underline">
                Resend
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotOTP;
